import { http } from './http.service';
import { FavListParams } from '@/types/favorites';

class FavoriteService {
  getFavoriteList = async (favListParams: FavListParams) => {
    const requestParam = favListParams.simpleSearchStr ? { simpleSearchStr: favListParams.simpleSearchStr } : {};
    const response = await http.post(
      `/api/favorite/list?pageSize=${favListParams.pageSize}&pageNo=${favListParams.pageNumber}`,
      requestParam
    );
    return response;
  };
  addToFavorite = async (catalogNumbers: string | string[]) => {
    const response = await http.post(`/api/favorite/addItemInFavorite`, { catalogNumbers: catalogNumbers });
    return response;
  };
  removeFavorite = async (catalogNumbers: string | string[]) => {
    const response = await http.post(`/api/favorite/deleteFavoriteItem`, { catalogNumbers: catalogNumbers });
    return response;
  };
  addToCartFavorite = async (catalogNumbers: string | string[]) => {
    const response = await http.post(`/api/favorite/addToCart`, { catalogNumbers: catalogNumbers });
    return response;
  };
  checkFavorite = async (catalogNumbers: string | string[]) => {
    const response = await http.get(`/api/favorite/checkItemsInFavorite?catalogNumberList=${catalogNumbers}`);
    return response;
  };
}
export const favoriteService = new FavoriteService();
